import { render, staticRenderFns } from "./ProductDesignFormArtwork2.vue?vue&type=template&id=b0fd6d86&"
import script from "./ProductDesignFormArtwork2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormArtwork2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports